import { createBrowserRouter, RouterProvider } from "react-router-dom";
import * as Sentry from "@sentry/react";

// eslint-disable-next-line import/no-unresolved
import "@manifesthhqinc/ui-library/dist/assets/generated-tokens/tokens.css";
import "./App.css";

import Home from "./pages/home";
import Launch from "./pages/launch";
import AppProvider from "./context/AppContext";
import TransferProvider from "./context/TransferContext";
import BridgeFlow from "./pages/bridge-flow";

if (process.env.REACT_APP_ENV !== "local") {
  Sentry.init({
    environment: process.env.REACT_APP_ENV,
    dsn: "https://976eefc374504456ad07eac9d48eb651@o384971.ingest.us.sentry.io/4507657598468096",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({
        maskAllInputs: false,
        maskAllText: false,
        mask: [".mask-input"],
      }),
      Sentry.extraErrorDataIntegration(),
    ],
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    ignoreErrors: ["AxiosError"],
  });
}

const router = createBrowserRouter([
  {
    path: "client/:clientId/launch/:launchId",
    element: <Launch />,
  },
  {
    path: "transfer",
    element: <BridgeFlow />,
  },
  {
    path: "*",
    element: <Home />,
  },
]);

function App() {
  return (
    <AppProvider>
      <TransferProvider>
        <RouterProvider router={router} />
      </TransferProvider>
    </AppProvider>
  );
}

export default App;
